import React from 'react';
import Loading from 'components/pure/utils/Loading';
import ReviewTypeDropdown from 'components/dashboard/common/ReviewTypeDropdown';
import GenericLink from 'components/GenericLink';
import {ColorDotWithTooltip} from 'components/utils/ColorDot';

export const CoachingReviewTypeDisplay = ({
  reviewType,
  changeReviewType = false,
  briefLabel = false,
}) => {
  const text = briefLabel ? reviewType.name : `Meeting Type: ${reviewType.name}`;
  const maybeLink = changeReviewType ? (
    <GenericLink onClick={changeReviewType}>{text}</GenericLink>
  ) : (
    text
  );

  return (
    <div className="review-type-banner">
      <div className="review-type-display">
        <ColorDotWithTooltip
          tooltip={reviewType.meetingCategory.name}
          color={reviewType.meetingCategory.color}
          size={12}
        />
        {maybeLink}
      </div>
    </div>
  );
};

export class CoachingReviewTypeDisplayAndChooser extends React.Component {
  constructor(props) {
    super(props);

    this.showChooser = this.showChooser.bind(this);

    this.state = {
      renderAgendaChooser: false,
      agendaSetting: false,
    };
  }

  showChooser() {
    this.setState({renderAgendaChooser: true});
  }

  /**
   * When we're waiting for the agenda to set,
   * use this `agendaSetting` flag to display a loader.
   * We know it set when we get a review with a review type id
   */
  componentDidUpdate() {
    const {agendaSetting} = this.state;
    const {review} = this.props;

    if (agendaSetting && review.reviewTypeId) {
      this.setState({agendaSetting: false});
    }
  }

  render() {
    const {review, reviewTypes, onSetReviewType} = this.props;
    const {renderAgendaChooser, agendaSetting} = this.state;

    if (agendaSetting) {
      return <Loading />;
    }

    const coachingReviewTypes = reviewTypes.filter((_, id) =>
      review.coachingPlan.reviewTypeIds.has(id)
    );

    if (renderAgendaChooser) {
      return (
        <div className="review-type-banner">
          <div className="agenda-select">
            <ReviewTypeDropdown
              placeholder={'Choose meeting type...'}
              coachingReviewTypes={coachingReviewTypes}
              onSelect={({id}) => {
                onSetReviewType(review, id);
                this.setState({
                  renderAgendaChooser: false,
                  agendaSetting: true,
                });
              }}
            />
          </div>
        </div>
      );
    }

    if (review.reviewTypeId) {
      const reviewType = coachingReviewTypes.get(review.reviewTypeId);
      // Coach can change the selected review type as long as the rep hasn't answered any
      // questions, providing there are types to choose from.
      const changeReviewType =
        review.recipientHasAnsweredQuestions || coachingReviewTypes.size <= 1
          ? null
          : this.showChooser;

      if (reviewType) {
        return (
          <CoachingReviewTypeDisplay reviewType={reviewType} changeReviewType={changeReviewType} />
        );
      } else {
        return null;
      }
    } else {
      return (
        <div className="review-type-banner">
          <GenericLink className="set-agenda" onClick={this.showChooser}>
            Select Meeting Type
          </GenericLink>
        </div>
      );
    }
  }
}
